import { SOFToolBrowseFilter } from '@models/interfaces';

export const SOF_TOOL_BROWSE_DEFAULT_CONFIGURE_FILTER: SOFToolBrowseFilter = {
  FALocationNumber: undefined,
  siteNumber: undefined,
  PACEProjectNumber: undefined,
  SS014ActualDate: undefined,
};
